/* WaterLand (v5 "visual") for Dawn 15.1.0. Ported from designs/assets/wl.js (contracts: designs/SHOPIFY-MAPPING.md).
   Dawn does the cart (product-form.js, cart-drawer.js), the variant swap (product-info.js) and the menu drawer
   (header-drawer). This file adds the v3 behaviour around them. Nothing about the baby is stored: the readiness
   answers live in memory only; the only URL state is ?variant=. */
(() => {
const d = document, w = window, root = d.documentElement;
/* perf (2026-10-22, pack 4): in-app browsers (Instagram, Facebook, TikTok, Snapchat, Pinterest, LinkedIn, Line) run pages
   slower than Safari; there the scroll reveals are skipped (wl.css, "wl-inapp") so scrolling stays smooth */
if (/Instagram|FBAN|FBAV|FB_IAB|FBIOS|musical_ly|BytedanceWebview|TikTok|Snapchat|Pinterest|LinkedInApp|GSA\/|\bLine\//i.test(navigator.userAgent)) root.classList.add('wl-inapp');
const $ = (s, r = d) => r.querySelector(s), $$ = (s, r = d) => [...r.querySelectorAll(s)];
/* perf (2026-10-22, pack 5): in in-app browsers, every photo the page shows is fetched and decoded right after load (at
   the first moment nothing is moving), so none is unpacked mid-swipe. Photos that aren't rendered (display: none, such
   as the colour tiles' hover photo on phones) are left alone. */
if (root.classList.contains('wl-inapp')) {
  /* perf (2026-10-26): two at a time, top of the page first, each next one at an idle moment. All ~25 at once (with
     the 3D's build) was a burst that landed while people were already scrolling */
  const warm = () => {
    const list = $$('img[loading="lazy"]').filter(i => i.getClientRects().length);
    const next = () => {
      const i = list.shift(); if (!i) return;
      const done = () => (w.requestIdleCallback ? w.requestIdleCallback(next, { timeout: 1000 }) : setTimeout(next, 60));
      const dec = () => (i.decode ? i.decode().catch(() => {}) : Promise.resolve()).then(done);
      i.loading = 'eager';
      if (i.complete && i.naturalWidth) dec(); else { i.addEventListener('load', dec, { once: true }); i.addEventListener('error', done, { once: true }); }
    };
    next(); next();
  };
  const later = () => setTimeout(() => (w.requestIdleCallback ? w.requestIdleCallback(warm, { timeout: 1500 }) : warm()), 800);
  if (d.readyState === 'complete') later(); else w.addEventListener('load', later, { once: true });
}
const RM = w.matchMedia('(prefers-reduced-motion: reduce)'), WIDE = w.matchMedia('(min-width: 990px)');
const say = (el, m) => { if (!el) return; el.textContent = ''; setTimeout(() => { el.textContent = m; }, 60); };
const ico = n => `<svg class="wl-ico" aria-hidden="true" focusable="false"><use href="#i-${n}"/></svg>`;
const tok = n => parseFloat(getComputedStyle(root).getPropertyValue(n)) || 0;
const smooth = e => RM.matches || e?.detail === 0 ? 'auto' : 'smooth';
const EO = 'cubic-bezier(.23,1,.32,1)';
const wurl = (u, x) => (u ? u + (u.includes('?') ? '&' : '?') + 'width=' + x : '');
const srcset = (u, ws) => ws.map(x => wurl(u, x) + ' ' + x + 'w').join(', ');
const readJSON = el => { try { return JSON.parse(el.textContent) || {}; } catch (x) { return {}; } };
/* can this browser draw WebGL? Asked once, before any spline-viewer is made: with WebGL off, the viewer throws
   "Error creating WebGL context", so the 3D views keep their packshot instead (window.wlHasGL, for the PDP too) */
let GL;
const hasGL = () => {
  if (GL === undefined) {
    GL = false;
    try { const c = d.createElement('canvas'), x = c.getContext('webgl2') || c.getContext('webgl'); GL = !!x; const l = x && x.getExtension('WEBGL_lose_context'); if (l) l.loseContext(); } catch (e) { GL = false; }
  }
  return GL;
};
w.wlHasGL = hasGL;
const strings = () => w.variantStrings || {};
root.classList.add('wl-js');
root.classList.toggle('wl-noshare', !navigator.share);

/* keyboard focus moves never smooth-scroll */
const kb = on => { root.style.scrollBehavior = on ? 'auto' : ''; };
d.addEventListener('keydown', e => { if (e.key === 'Tab') kb(1); });
d.addEventListener('pointerdown', () => kb(0));

/* ---------- native <dialog>s (the readiness check) ---------- */
let bar;
const cartEl = () => $('cart-drawer');
const sync = () => { root.classList.toggle('wl-has-dlg', !!$('dialog[open]:not(.wl-is-out)')); bar && bar.upd && bar.upd(); };
const open = (el, trig) => {
  if (!el || el.hasAttribute('open')) return;
  el._t = trig || d.activeElement;
  el.classList.remove('wl-is-out');
  el.showModal ? el.showModal() : el.setAttribute('open', '');
  sync();
  el.dispatchEvent(new Event('wl:open'));
};
const close = el => {
  if (!el || !el.hasAttribute('open') || el.classList.contains('wl-is-out')) return;
  el.classList.add('wl-is-out');
  const p = $('.wl-dialog__panel', el); if (p) p.style.transform = '';
  sync();
  setTimeout(() => {
    el.close ? el.close() : el.removeAttribute('open');
    el.classList.remove('wl-is-out'); sync();
    const t = el._t; if (t && t.isConnected && t.focus) t.focus();
  }, tok('--t-exit') + 10);
};
d.addEventListener('cancel', e => { if (e.target.tagName === 'DIALOG') { e.preventDefault(); close(e.target); } }, true);

/* ---------- page data: the product's colours ---------- */
const PI = $('product-info[id^="MainProduct-"]');
const VJ = PI && $('[data-wl-variants]', PI);
const V = VJ ? readJSON(VJ) : {};
const own = k => k != null && Object.prototype.hasOwnProperty.call(V, k);
const mainFormId = PI ? 'product-form-' + PI.dataset.section : '';
const priceText = () => ($('.wl-buybox__amt', PI || d) || {}).textContent || '';
let cur = null, shown = null;

const btns = (r = d) => {
  const v = V[cur]; if (!v) return;
  const s = strings();
  $$('[data-buybar-btn]', r).forEach(b => {
    if (b.closest('product-form')) return; /* never touch a button Dawn's product-form owns */
    if (mainFormId && !b.getAttribute('form')) b.setAttribute('form', mainFormId);
    b.type = v[1] ? 'submit' : 'button';
    const long = (PI && PI.dataset.notifyLong || 'Notify me when [color] is back').replace('[color]', v[0]);
    b.firstElementChild.textContent = v[1] ? (s.addToCart || 'Add to bag') : b.hasAttribute('data-long') ? long : (PI && PI.dataset.notifyShort || 'Notify me');
    $$('[data-wl-price]', b).forEach(p => { p.textContent = priceText(); });
    /* the header pill shows the colour as a dot (data-tint); screen readers hear it: "Add to bag, Light Blue Sky, $99" */
    if (b.hasAttribute('data-hdr-buy')) b.setAttribute('aria-label', `${b.firstElementChild.textContent}, ${v[0]}, ${priceText().trim()}`);
  });
};
const toNotify = e => {
  const m = $('[data-atc-main]');
  if (!m) return;
  m.scrollIntoView({ block: 'center', behavior: smooth(e) });
  setTimeout(() => $('[data-notify] input[type="email"]')?.focus(), 400);
};
const land = el => RM.matches || el.animate([{ opacity: 0.25, filter: 'blur(6px)' }, { opacity: 1, filter: 'blur(0)' }], { duration: 200, easing: EO });
const setVariant = (id, init) => {
  id = String(id);
  if (!own(id)) return;
  const v = V[id], same = id === cur;
  cur = id;
  $$('[data-color-name]').forEach(el => { el.textContent = v[0]; });
  $$('[data-tint]').forEach(el => { el.style.setProperty('--tint', v[4]); el.style.setProperty('--c', v[3]); });
  $$('[data-pack], [data-pack-back]').forEach(el => {
    const f = v[el.hasAttribute('data-pack') ? 2 : 5]; if (!f) return;
    const ws = el.closest('.wl-macro') ? [960, 1200, 1600, 2000] : [480, 720, 960];
    el.srcset = srcset(f, ws); el.src = wurl(f, ws[1]);
    if (shown) el.alt = el.alt.replace(shown, v[0]);
    if (!same && !init) land(el);
  });
  shown = v[0];
  $$('button[data-pick]').forEach(b => b.setAttribute('aria-pressed', b.dataset.pick === id));
  const s = strings();
  $$('form[data-type="add-to-cart-form"]').forEach(f => {
    if (f.closest('[data-stage]') || f.id === mainFormId) return; /* Dawn updates the main form; the stage keeps its own pick */
    const i = $('input[name="id"]', f); if (!i || i.dataset.fixed) return;
    i.value = id;
    const b = $('[name="add"]', f);
    if (b) { b.disabled = !v[1]; const sp = $('span', b); if (sp) sp.textContent = v[1] ? (s.addToCart || 'Add to bag') : (s.soldOut || 'Sold out'); }
  });
  $$('[data-if-avail]').forEach(el => { el.hidden = !v[1]; });
  $$('[data-if-out]').forEach(el => { el.hidden = !!v[1]; });
  btns();
  const body = $('[data-wl-notify-body]');
  if (body) body.value = body.dataset.wlNotifyBody.replace('[color]', v[0]).replace('[variant]', id);
  if (!init && !same) {
    const nf = $('#notify');
    if (nf) { $$('[data-wl-fields]', nf).forEach(x => { x.hidden = false; }); $$('[data-wl-done]', nf).forEach(x => { x.hidden = true; }); }
    say($('[data-variant-status]'), `${v[0]}${v[1] ? '' : ', ' + (s.soldOut || 'sold out').toLowerCase()}.`);
  }
};
const pick = (id, src) => {
  if (!PI || !own(String(id))) return false;
  const r = $$('variant-selects input[data-variant-id]', PI).find(i => i.dataset.variantId === String(id));
  if (!r) return false;
  setVariant(id);
  if (!r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
  if (!src || !src.hasAttribute('data-stay')) r.focus();
  return true;
};
const galleryReset = () => {
  const g = PI && $('[data-gallery]', PI); if (!g) return;
  const t = $('.wl-gallery__track', g); if (!t) return;
  [...t.children].forEach((li, i) => { li.hidden = false; const img = $('img', li); if (img && !i) { img.loading = 'eager'; } });
  t.scrollLeft = 0;
  const sc = $('slider-component', g); sc && sc.resetPages && sc.resetPages();
  t.tabIndex = t.scrollWidth > t.clientWidth + 2 ? 0 : -1;
};
if (PI) {
  d.addEventListener('change', e => { const r = e.target.closest && e.target.closest('variant-selects input[data-variant-id]'); if (r && PI.contains(r)) setVariant(r.dataset.variantId); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ev => { const vid = ev && ev.data && ev.data.variant && ev.data.variant.id; if (vid) setVariant(String(vid)); galleryReset(); });
  }
  const sel = $('variant-selects [data-selected-variant]', PI), sv = sel ? readJSON(sel) : {};
  const first = Object.keys(V).find(k => V[k][1]) || Object.keys(V)[0];
  setVariant(String(sv.id || first), true);
  galleryReset();
  /* a phone's URL bar resizes the window while scrolling: only refresh the track's tab stop, never its position */
  w.addEventListener('resize', () => { const t = $('.wl-gallery__track', PI); if (t) t.tabIndex = t.scrollWidth > t.clientWidth + 2 ? 0 : -1; });
}

/* ---------- clicks ---------- */
d.addEventListener('click', e => {
  const x = s => e.target.closest(s);
  const c = x('[data-close]') || (e.target.tagName === 'DIALOG' && e.target);
  if (c) close(c.closest('dialog'));
  const mc = x('[data-wl-menu-close]');
  if (mc) { const det = mc.closest('details'), s = det && $('summary', det); if (s && det.open) s.click(); }
  const a = x('[data-pick]');
  if (a && pick(a.dataset.pick, a)) e.preventDefault();
  const b = x('[data-buybar-btn][type="button"], [data-wl-notify]');
  if (b) { const cd = b.closest('dialog'); if (cd) close(cd); toNotify(e); }
  const h = x('a[href^="#"]');
  if (h && h.hash.length > 1) { reveal(h.hash); if (!e.detail) kb(1); }
  if (x('.wl-footer summary')) e.preventDefault();
  const o = x('[data-open]');
  const el = o && d.getElementById(o.dataset.open);
  if (!el || el.tagName !== 'DIALOG') return;
  e.preventDefault();
  if (el.id === 'check') el.dataset.mode = o.dataset.mode || '';
  const curD = o.closest('dialog');
  if (curD && curD !== el) { close(curD); setTimeout(() => open(el, o), tok('--t-exit') + 20); } else open(el, o);
});

/* ---------- header (v5): always in view (sticky, wl.css). Transparent over the first section's full-bleed picture
   (Home's hero, a page's cover, an article's cover) until it, or the words on it, have scrolled under the bar; then
   .wl-is-solid makes it white. .wl-is-scrolled marks "something is under a white bar" (no shadow in v5; kept for older selectors, as is
   .wl-is-compact). Looked up on every call, so a header reloaded by the theme editor keeps working. rAF-throttled. */
let hdrRaf = 0;
/* perf (2026-10-22): the first section's hero and its words are looked up once, not on every scroll frame; a section
   the theme editor reloads clears the cache (shopify:section:load below) */
let heroC, wordsC;
const heroOf = () => {
  if (heroC === undefined || (heroC && !heroC.isConnected)) {
    heroC = $('#MainContent > .shopify-section:first-child :is(.wl-hero, .wl-cover, .wl-jart__cover)') || null;
    wordsC = heroC && $(':is(.wl-hero__h1, .wl-phero__words > :first-child)', heroC);
  }
  return heroC;
};
const headerState = () => {
  hdrRaf = 0;
  const hdr = $('.wl-header'); if (!hdr) return;
  const sh = hdr.closest('.section-header');
  const y = w.scrollY, hh = hdr.offsetHeight || tok('--hdr-h') * 10;
  let hero = hdr.classList.contains('wl-header--over') && heroOf();
  /* a split hero (photo beside the words) has no picture under the bar on desktop: the header stays solid */
  if (hero && hero.matches('.wl-hero--d-split') && WIDE.matches) hero = null;
  /* v6 fix: it also turns solid once the hero's words (its title, then the line and the pill) scroll up to the bar,
     so a pill never slides under the clear header's logo on the way out */
  const hb = hdr.getBoundingClientRect().bottom;
  const words = hero && wordsC;
  const solid = !hero || hero.getBoundingClientRect().bottom <= hb + 1 || (y > 2 && !!words && words.getBoundingClientRect().top <= hb + 1);
  hdr.classList.toggle('wl-is-solid', solid);
  hdr.classList.toggle('wl-is-scrolled', solid && y > 2);
  hdr.classList.toggle('wl-is-compact', solid && y > 2);
  if (sh) sh.classList.toggle('scrolled-past-header', y > hh);
  const hs = hh + 'px';
  if (hs !== headerState.h) { headerState.h = hs; root.style.setProperty('--header-height', hs); }
};
const askHeader = () => { if (!hdrRaf) hdrRaf = requestAnimationFrame(headerState); };
headerState();
w.addEventListener('scroll', askHeader, { passive: true });
w.addEventListener('resize', askHeader);

/* ---------- chip marquee (wl-marquee): one Pause control per row; the row drifts, and hands can move it (initMarquee below) ---------- */
d.addEventListener('click', e => {
  const b = e.target.closest('[data-marquee-ctl]'), m = b && b.closest('[data-marquee]'); if (!m) return;
  const off = !m.hasAttribute('data-paused');
  m.toggleAttribute('data-paused', off);
  b.setAttribute('aria-pressed', off);
  b.setAttribute('aria-label', off ? (b.dataset.play || 'Play') : (b.dataset.pause || 'Pause'));
  const u = $('use', b); if (u) u.setAttribute('href', off ? '#i-play' : '#i-pause');
});

/* The row is a scroller (no scrollbar) that wl.js drifts by scrollLeft: one set's width per --dur seconds. Swipe, wheel and
   mouse drag move it by hand (native momentum for touch); the drift then waits 2.5s after the last touch. It also waits while
   a mouse hovers it, a chip has keyboard focus, or Pause is on, and never runs under reduced motion (it still moves by hand).
   It loops both ways: copies of the set sit on each side and scrollLeft steps by one set's width, in the same frame while it
   drifts or is dragged, and once a flick has stopped, so native momentum is never cut. A drag of more than 6px never taps a chip. */
const initMarquee = m => {
  if (m.dataset.wlInit) return; m.dataset.wlInit = '1';
  const vp = $('.wl-marquee__viewport', m), tr = $('.wl-marquee__track', m), set = $('.wl-marquee__list', tr);
  if (!vp || !set) return;
  $$('.wl-marquee__list', tr).slice(1).forEach(x => x.remove()); /* the markup's own copy: wl.js makes as many as it needs */
  $$('a', set).forEach(a => { a.draggable = false; });
  let W = 0, VW = 0, N = 0, base = 0, pos = 0, spd = 0, until = 0, dn = 0, hov = 0, foc = 0, was = 0, raf = 0, last = 0, tm = 0, drag = 0, moved = 0, sx = 0, s0 = 0;
  const hold = () => { until = performance.now() + 2500; };
  const copy = () => { const c = set.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.dataset.mqCopy = ''; $$('a', c).forEach(a => { a.tabIndex = -1; }); return c; };
  /* measure one set (+ its gap = the wrap distance W) and keep enough copies each side for a long flick; the view stays put */
  const lay = () => {
    const vw = vp.clientWidth, g = parseFloat(getComputedStyle(tr).columnGap) || 0, nw = set.getBoundingClientRect().width + g;
    if (!vw || nw <= g || (Math.abs(nw - W) < .5 && vw === VW)) return;
    const ph = W ? (((vp.scrollLeft - base) % W) + W) % W / W : 0, n = Math.min(24, Math.max(1, Math.ceil((2400 + vw + g) / nw)));
    if (n !== N) { $$('[data-mq-copy]', tr).forEach(x => x.remove()); for (let i = 0; i < n; i++) { tr.prepend(copy()); tr.append(copy()); } N = n; }
    W = nw; VW = vw; base = n * W; pos = base + ph * W; vp.scrollLeft = pos;
    spd = W / (parseFloat(getComputedStyle(m).getPropertyValue('--dur')) || 48) / 1000; /* px per ms */
  };
  /* back into the middle set; returns how far it moved (0 while a chip has keyboard focus, which stays where it is) */
  const norm = () => {
    if (!W || foc) return 0;
    const x = vp.scrollLeft, y = base + (((x - base) % W) + W) % W;
    if (Math.abs(y - x) < .5) return 0;
    vp.scrollLeft = pos = y; return y - x;
  };
  const tick = t => {
    raf = requestAnimationFrame(tick);
    const dt = last ? Math.min(Math.max(t - last, 0), 64) : 0; last = t; /* a slow frame never lurches the row */
    if (!W || RM.matches || m.hasAttribute('data-paused') || dn || hov || foc || t < until) { was = 0; return; }
    if (!was) { pos = vp.scrollLeft; was = 1; }
    pos += spd * dt;
    if (pos >= base + W) pos -= W; else if (pos < base) pos += W;
    vp.scrollLeft = pos;
  };
  new IntersectionObserver(([e]) => { /* drifts only while it is on screen */
    if (e.isIntersecting && !raf) raf = requestAnimationFrame(tick);
    else if (!e.isIntersecting) { cancelAnimationFrame(raf); raf = 0; last = 0; }
  }).observe(m);
  const ro = new ResizeObserver(lay); ro.observe(vp); ro.observe(set);
  lay();
  /* somebody else moved it (wheel, swipe momentum, drag, keys): wait, then step back to the middle set once it has settled */
  vp.addEventListener('scroll', () => {
    if (Math.abs(vp.scrollLeft - pos) < 2) return;
    pos = vp.scrollLeft; hold();
    clearTimeout(tm); tm = setTimeout(() => { if (!dn) norm(); }, 150);
    if (!dn && (pos < VW || pos > vp.scrollWidth - 2 * VW)) norm(); /* nearly at an end of the copies: step now */
  }, { passive: true });
  vp.addEventListener('wheel', e => { if (e.shiftKey || Math.abs(e.deltaX) > Math.abs(e.deltaY)) hold(); }, { passive: true }); /* a plain vertical wheel is the page's */
  vp.addEventListener('touchstart', () => { dn = 1; }, { passive: true });
  ['touchend', 'touchcancel'].forEach(t => vp.addEventListener(t, e => { dn = e.touches.length ? 1 : 0; hold(); }, { passive: true }));
  vp.addEventListener('pointerenter', e => { hov = e.pointerType === 'mouse' ? 1 : 0; });
  vp.addEventListener('pointerleave', e => { hov = 0; if (e.pointerType === 'mouse' && !drag) dn = 0; }); /* a press that left the row unreleased must not freeze it */
  vp.addEventListener('focusin', e => { /* a chip with keyboard focus holds the row, and is brought fully into view, clear of the fades */
    const c = e.target; foc = c.matches(':focus-visible') ? 1 : 0; hold();
    if (!dn) requestAnimationFrame(() => {
      const r = c.getBoundingClientRect(), v = vp.getBoundingClientRect(), pd = parseFloat(getComputedStyle(vp).scrollPaddingLeft) || 0, l = r.left - v.left - pd, rt = v.right - pd - r.right;
      if (l < 0) vp.scrollLeft += l; else if (rt < 0) vp.scrollLeft += Math.min(-rt, l);
    });
  });
  vp.addEventListener('focusout', () => { foc = 0; hold(); });
  /* mouse drag: scrolls after 6px, then holds the pointer so it can leave the row; the click that ends it is swallowed */
  vp.addEventListener('pointerdown', e => {
    if (e.pointerType !== 'mouse' || e.button) return;
    dn = 1; moved = 0; drag = 0; sx = e.clientX; s0 = vp.scrollLeft; hold();
  });
  vp.addEventListener('pointermove', e => {
    if (!dn || e.pointerType !== 'mouse' || !(e.buttons & 1)) return;
    const dx = e.clientX - sx;
    if (!drag && Math.abs(dx) <= 6) return;
    if (!drag) { drag = moved = 1; vp.classList.add('wl-is-drag'); try { vp.setPointerCapture(e.pointerId); } catch (x) {} }
    vp.scrollLeft = s0 - dx; s0 += norm(); hold();
  });
  const end = e => {
    if (e.pointerType !== 'mouse') return;
    if (drag) { vp.classList.remove('wl-is-drag'); try { vp.releasePointerCapture(e.pointerId); } catch (x) {} }
    dn = drag = 0; hold(); setTimeout(() => { moved = 0; });
  };
  vp.addEventListener('pointerup', end); vp.addEventListener('pointercancel', end);
  vp.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  vp.addEventListener('dragstart', e => e.preventDefault());
};

/* footer link groups (v5): open columns at every width; an older footer's <details> stay open */
const fo = () => $$('.wl-footer details').forEach(x => { x.open = true; if (x.firstElementChild) x.firstElementChild.tabIndex = -1; });
fo();

/* ---------- colour stage (home) ---------- */
const initStage = s => {
  if (s.dataset.wlInit) return; s.dataset.wlInit = '1';
  const SV = readJSON($('[data-wl-variants]', s) || { textContent: '{}' }), sown = k => Object.prototype.hasOwnProperty.call(SV, k);
  const pic = $('[data-stage-imgs]', s), word = $('[data-stage-name]', s), im = pic ? $$('img', pic) : []; /* word: loop 1's ghost name, gone in loop 2 */
  const form = $('product-form', s), f = form && $('input[name="id"]', form), add = form && $('[name="add"]', form);
  const nfy = $('[data-stage-notify]', s), lnk = $('[data-stage-link]', s), purl = s.dataset.productUrl || '';
  const pre = () => Object.keys(SV).forEach(k => [2, 5].forEach(n => { if (!SV[k][n] || !im[0]) return; const i = new Image(); i.sizes = im[0].sizes; i.srcset = srcset(SV[k][n], [480, 720, 960]); }));
  s.addEventListener('pointerover', pre, { once: true }); s.addEventListener('focusin', pre, { once: true });
  s.addEventListener('change', e => {
    const id = e.target.value; if (!e.target.hasAttribute('data-wl-pick') || !sown(id)) return;
    const v = SV[id], so = !v[1], st = strings();
    const swap = () => {
      if (word) word.textContent = v[0];
      im.forEach((i, n) => { const fl = v[n ? 5 : 2]; if (!fl) return; i.srcset = srcset(fl, [480, 720, 960]); i.src = wurl(fl, 720); if (i.alt) i.alt = i.alt.replace(/ in .+?, (front|back)/, ` in ${v[0]}, $1`); });
    };
    s.style.setProperty('--tint', v[4]); s.style.setProperty('--c', v[3]);
    const lab = $('[data-stage-label]', s); if (lab) lab.textContent = v[0];
    const stock = $('[data-stage-stock]', s); if (stock) stock.textContent = so ? s.dataset.out : s.dataset.in;
    if (f) f.value = id;
    if (form) form.hidden = so;
    if (add && !so) { add.disabled = false; const sp = $('span', add); if (sp) sp.textContent = st.addToCart || 'Add to bag'; }
    if (nfy) { nfy.hidden = !so; nfy.href = `${purl}?variant=${id}#notify`; }
    if (lnk) lnk.href = `${purl}?variant=${id}`;
    say($('[data-stage-status]', s), `${v[0]}, ${so ? s.dataset.out : s.dataset.in}.`);
    if (RM.matches || !pic) return swap();
    /* a quiet cross-fade: the old colour out in 120ms, the new one in over 200ms (no bounce, no rotation) */
    const out = pic.animate([{}, { opacity: 0, transform: 'scale(.97)' }], { duration: 120, easing: EO, fill: 'forwards' });
    setTimeout(() => {
      swap(); out.cancel();
      pic.animate([{ opacity: 0, transform: 'scale(.97)' }, { opacity: 1, transform: 'none' }], { duration: 200, easing: EO });
      if (word) word.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: EO });
    }, 120);
  });
};

/* ---------- forms: First Water Day (customer), notify me (contact); no reload where possible ---------- */
const done = f => {
  $$('[data-wl-fields]', f).forEach(x => { x.hidden = true; });
  const ok = $('[data-wl-done]', f) || $('[data-wl-done]', f.parentNode);
  if (ok) { ok.hidden = false; ok.focus(); }
};
d.addEventListener('submit', async e => {
  const f = e.target;
  if (f.matches('form[data-type="add-to-cart-form"]')) {
    /* close the readiness sheet first, so Dawn's cart drawer never opens under the top-layer dialog */
    const cd = e.submitter && e.submitter.closest('dialog');
    if (cd) close(cd);
    return;
  }
  if (!f.dataset.wlAjax) return;
  const em = f.elements['contact[email]'], err = $('[data-err]', f);
  if (em && !em.checkValidity()) { e.preventDefault(); em.setAttribute('aria-invalid', 'true'); say(err, err ? err.dataset.msg : ''); em.focus(); return; }
  if (em) em.removeAttribute('aria-invalid');
  const tags = f.elements['contact[tags]'], mo = f.elements.wl_month, sg = $('input[name="wl_stage"]:checked', f);
  if (tags && mo) tags.value = `first-water-day,fwd-${mo.value}` + (sg ? `,fwd-stage-${sg.value}` : '');
  if (f.dataset.wlSent || !w.fetch || !w.DOMParser) return;
  e.preventDefault();
  try {
    const res = await fetch(f.action, { method: 'POST', body: new FormData(f), headers: { Accept: 'text/html' } });
    if (/[?&](customer|contact)_posted=true/.test(res.url)) return done(f);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const twin = f.id && doc.getElementById(f.id), te = twin && $('[data-err]', twin);
    if (res.ok && te && te.textContent.trim()) { say(err, te.textContent.trim()); if (em) { em.setAttribute('aria-invalid', 'true'); em.focus(); } return; }
    throw new Error('post');
  } catch (x) { f.dataset.wlSent = '1'; f.submit(); } /* a challenge page or anything unexpected: post the normal way */
}, true);
d.addEventListener('change', e => {
  if (e.target.name !== 'wl_stage') return;
  const form = e.target.form || e.target.closest('form'), l = form && $('[data-occasion]', form); if (!l) return;
  l.dataset.self = l.dataset.self || l.textContent;
  l.textContent = e.target.hasAttribute('data-gift-stage') ? l.dataset.occasion : l.dataset.self;
});

/* ---------- share: only ?variant travels ---------- */
const link = () => { const u = new URL(location.pathname, location.href); if (PI && cur) u.searchParams.set('variant', cur); u.searchParams.set('utm_source', 'share'); return u.href; };
d.addEventListener('click', async e => {
  const b = e.target.closest('[data-share],[data-copy]'); if (!b) return;
  const row = b.closest('.wl-share') || d, st = $('[data-share-status]', row);
  if (b.hasAttribute('data-share')) { try { await navigator.share({ title: d.title, text: b.dataset.share, url: link() }); } catch (x) {} return; }
  try { await navigator.clipboard.writeText(link()); say(st, 'Link copied.'); } catch (x) {
    let f = $('input', row);
    if (!f) { row.insertAdjacentHTML('beforeend', '<input class="wl-input wl-share__url" readonly aria-label="Link to copy">'); f = $('input', row); }
    f.value = link(); f.select(); say(st, 'Copy the link below.');
  }
});

/* FAQ: a link or hash to a question opens it */
const reveal = h => { let t = null; try { t = h && d.getElementById(decodeURIComponent(h.slice(1))); } catch (x) {} if (t && t.tagName === 'DETAILS') t.open = true; return t; };
reveal(location.hash); w.addEventListener('hashchange', () => reveal(location.hash));

/* checklist card: Print prints that card only (wl.css, print) */
d.addEventListener('click', e => { const c = e.target.closest('[data-wl-print]') && e.target.closest('.wl-ccard'); if (!c) return; root.classList.add('wl-print-one'); c.classList.add('wl-is-print'); w.print(); });
w.addEventListener('afterprint', () => { root.classList.remove('wl-print-one'); $$('.wl-is-print').forEach(c => c.classList.remove('wl-is-print')); });

/* ---------- readiness check: answers in memory only ---------- */
const ck = $('#check');
if (!ck) $$('[data-open="check"]').forEach(el => { el.hidden = true; });
if (ck) {
  const wrap = ck.closest('[data-wl-readiness]') || d, A = {};
  const giftOn = ck.dataset.giftOn !== 'false';
  if (!giftOn) $$('[data-wl-gift-only]').forEach(el => { el.hidden = true; });
  const S = n => $(`[data-step="${n}"]`, ck), res = S('result');
  const back = $('[data-back]', ck), skip = $('[data-skip]', ck), next = $('[data-next]', ck);
  const prog = $$('.wl-prog i', ck), ptxt = $('[data-prog-txt]', ck), line = $('[data-result-line]');
  const aMin = +ck.dataset.ageMin || 4, aMax = +ck.dataset.ageMax || 24;
  let seq = [], si = 0, advT = 0, gift = false;
  const pk = n => $(`input[name="${n}"]:checked`, ck), rng = n => ((pk(n) && pk(n).dataset.r) || '0 12').split(' ').map(Number);
  const asks = () => !!(pk('age') && pk('age').hasAttribute('data-ask'));
  const plan = () => { seq = gift ? ['age', ...(asks() ? ['gwhen'] : []), 'result'] : ['age', 'head', 'weight', 'result']; };
  const stop = () => clearTimeout(advT);
  const verdict = () => {
    const { age: g, head: h, weight: wt } = A;
    if (g === 'over' || wt === 'over') return 'outside';
    if (g === 'lt' || h === 'not-yet' || wt === 'lt') return 'notyet';
    if (!g || !h || !wt || h === 'not-sure' || wt === 'not-sure') return 'check';
    return 'within';
  };
  const gv = () => {
    if (!A.age) return { k: 'edge' };
    const [lo, hi] = rng('age'), [dl, dh] = asks() ? rng('gwhen') : [0, 12], a = lo + dl, b = hi + dh;
    return { k: a > aMax ? 'past' : a >= aMin && b <= aMax ? 'in' : 'edge', n: Math.round((a + b) / 2), start: a < aMin };
  };
  const nav = () => {
    plan(); const q = seq.length - 1;
    next.disabled = !A[seq[si]];
    next.textContent = si === q - 1 ? next.dataset.seeLabel : next.dataset.nextLabel;
    prog.forEach((p, j) => { p.hidden = j >= q; p.classList.toggle('wl-on', j <= si); });
    ptxt.textContent = si === q ? ptxt.dataset.res : `${ptxt.dataset.q} ${si + 1}` + (gift ? '' : ` ${ptxt.dataset.of} 3`);
  };
  const show = (i, focus = true) => {
    stop(); plan(); si = i;
    const nm = seq[i], isRes = nm === 'result';
    $$('[data-step]', ck).forEach(s => { s.hidden = s.dataset.step !== nm; });
    back.hidden = !i || isRes; skip.hidden = isRes || (gift && !i); next.hidden = isRes;
    nav();
    if (focus) { const t = $('[tabindex="-1"]', S(nm)); if (t) t.focus(); }
  };
  const result = () => {
    const g = gift ? gv() : {}, k = gift ? 'gift-' + g.k : verdict(), fl = { asked: asks(), start: g.start, end: !g.start && !!A.age };
    const on = f => { const [n, v] = f.split('='); return v == null ? fl[n] : (A[n] || '') === v; };
    const tp = $(`template[data-wl-result="${k}"]`, wrap);
    if (!tp) return;
    const t = tp.content.cloneNode(true);
    $$('[data-if]', t).forEach(el => { if (!el.dataset.if.split(' ').some(on)) el.remove(); });
    $$('[data-if-not]', t).forEach(el => { if (el.dataset.ifNot.split(' ').some(on)) el.remove(); });
    $$('[data-n]', t).forEach(el => { el.textContent = g.n; });
    $$('[data-now]', t).forEach(el => { const a = pk('age'); el.textContent = a ? a.nextElementSibling.textContent.trim() : ''; });
    $('[data-result-body]', res).replaceChildren(t);
    btns(res);
    if (line) line.innerHTML = `<span class="wl-rline wl-rline--${String(k).replace(/[^\w-]/g, '')}">${ico(String(tp.dataset.ico || '').replace(/[^\w-]/g, ''))}<span></span><button type="button" data-open="check" data-mode="${gift ? 'gift' : ''}" aria-label=""></button></span>`;
    if (line) { const sp = $('.wl-rline > span', line), eb = $('button', line); sp.textContent = tp.dataset.line; eb.textContent = ck.dataset.edit || 'Edit'; eb.setAttribute('aria-label', ck.dataset.editAria || 'Edit your answers'); }
    show(seq.length - 1);
  };
  const adv = () => { if (!A[seq[si]]) return; plan(); seq[si + 1] === 'result' ? result() : show(si + 1); };
  const mode = g => {
    g = g && giftOn;
    if (g !== gift) { for (const k in A) delete A[k]; $$('.wl-opt input', ck).forEach(r => { r.checked = false; }); }
    gift = g; ck.dataset.mode = g ? 'gift' : '';
    $$('[data-gift]').forEach(el => { el.dataset.self = el.dataset.self || el.textContent; el.textContent = g ? el.dataset.gift : el.dataset.self; });
    show(0);
  };
  ck.addEventListener('change', e => { const n = e.target.name; if (n in { age: 1, head: 1, weight: 1, gwhen: 1 }) { A[n] = e.target.value; nav(); } });
  ck.addEventListener('click', e => {
    const o = e.target.closest('.wl-opt input');
    if (o && e.detail > 0) { stop(); const from = si; advT = setTimeout(() => { if (si === from) adv(); }, RM.matches ? 0 : 260); }
    if (e.target.closest('[data-restart]')) show(0);
    if (e.target.closest('[data-mode-switch]')) mode(!gift);
  });
  next.addEventListener('click', adv);
  back.addEventListener('click', () => show(Math.max(0, si - 1)));
  skip.addEventListener('click', () => { stop(); const nm = seq[si]; delete A[nm]; $$(`input[name="${nm}"]`, ck).forEach(r => { r.checked = false; }); seq[si + 1] === 'result' ? result() : show(si + 1); });
  ck.addEventListener('wl:open', () => mode(ck.dataset.mode === 'gift'));
  ck.addEventListener('pointerdown', () => { ck.dataset.how = 'p'; }, true);
  ck.addEventListener('keydown', () => { ck.dataset.how = 'k'; }, true);
  const hs = location.hash;
  if (/^#check(-gift)?$/.test(hs)) { ck.dataset.mode = hs.length > 6 ? 'gift' : ''; setTimeout(() => open(ck), 300); }
}

/* ---------- phones: drag (or flick) the sheet down, the bag right, to dismiss ---------- */
const drag = (box, getPan, grip, ax, shut) => {
  let p0 = 0, t0 = 0, dd = 0, on = false, pan = null;
  box.addEventListener('pointerdown', e => {
    if (WIDE.matches || !e.target.closest(grip) || e.target.closest('button, a')) return;
    pan = getPan(); if (!pan) return;
    on = true; p0 = e[ax]; t0 = Date.now(); dd = 0; pan.setPointerCapture(e.pointerId); box.classList.add('wl-is-drag');
  });
  box.addEventListener('pointermove', e => { if (!on) return; dd = e[ax] - p0; const m = dd > 0 ? dd : dd / 6; pan.style.transform = ax === 'clientY' ? `translateY(${m}px)` : `translateX(${m}px)`; });
  const end = () => { if (!on) return; on = false; box.classList.remove('wl-is-drag'); const go = dd > 110 || dd / Math.max(1, Date.now() - t0) > 0.11; pan.style.transform = ''; if (go) shut(); };
  box.addEventListener('pointerup', end); box.addEventListener('pointercancel', end);
};
if (ck) drag(ck, () => $('.wl-dialog__panel', ck), '.wl-sheet__grab, .wl-sheet__head', 'clientY', () => close(ck));
const bag = cartEl();
if (bag) {
  drag(bag, () => $('.drawer__inner', bag), '.drawer__header', 'clientX', () => bag.close && bag.close());
  new MutationObserver(() => sync()).observe(bag, { attributes: true, attributeFilter: ['class'] });
}
const menu = $('.menu-drawer-container');
if (menu) new MutationObserver(() => sync()).observe(menu, { attributes: true, attributeFilter: ['class'] });

/* ---------- the phone buy bar: its logic lives with it, in wl-main-product's script (on only once the in-page Add to
   bag has scrolled up past the header; off from the FAQ or the footer on, and while a dialog is open). sync() asks it
   again (bar.upd) whenever a dialog, the bag or the menu opens or closes. ---------- */
bar = $('.wl-buybar');
const main = $('[data-atc-main]');
/* desktop product page: the header's buy pill comes back once the buy box's own button has scrolled away (CSS shows
   it from 990px only; the phone has the bar). It stays while you read on, as the header's one action. */
const hb = $('[data-hdr-buy]');
if (hb && main) {
  const hset = on => { hb.classList.toggle('wl-is-on', on); hb.tabIndex = on ? 0 : -1; hb.setAttribute('aria-hidden', !on); };
  hset(false);
  new IntersectionObserver(([e]) => hset(!e.isIntersecting && e.boundingClientRect.top < 0)).observe(main);
} else if (hb) hb.remove();

/* ---------- scroll progress (signature moments on content pages): [data-wl-progress] gets --wl-p from 0 to 1 and
   data-wl-step (0…n-1 with data-wl-steps="n"). "pin" (default): across a tall section whose child sticks, from its top
   at the viewport's top to its bottom at the viewport's bottom. "pass": from entering at the bottom to leaving at the
   top. Reduced motion: the end state at once. rAF-throttled, and only while the element is near the screen. ---------- */
/* perf (2026-10-22): where this browser runs the pinned drift as a CSS scroll-driven animation (wl.css, 23d: its
   cards carry the wl-drift animation), the compositor moves the cards and this script leaves that section alone.
   Anywhere the animation isn't running (older browsers, reduced motion, the theme editor) it works as before. */
const cssDriven = el => { const c = $('.wl-pinned-drift__card', el); return !!c && /(^|[\s,])wl-drift([\s,]|$)/.test(getComputedStyle(c).animationName || ''); };
const progs = $$('[data-wl-progress]').filter(el => !cssDriven(el));
/* the drifting photos sit below their clipped stage until they move in, so the browser's own lazy loading would fetch
   them only as they drift in: fetch them once the section is a screen away */
if ('IntersectionObserver' in w) $$('.wl-pinned-drift').forEach(sec => {
  const o = new IntersectionObserver(([e]) => { if (!e.isIntersecting) return; o.disconnect(); $$('img[loading="lazy"]', sec).forEach(i => { i.loading = 'eager'; }); }, { rootMargin: '100% 0px' });
  o.observe(sec);
});
if (progs.length) {
  const near = new Set();
  const setP = (el, p) => {
    el.style.setProperty('--wl-p', p.toFixed(3));
    const n = +el.dataset.wlSteps || 0;
    if (n) el.dataset.wlStep = Math.min(n - 1, Math.floor(p * n));
  };
  let praf = 0;
  const tick = () => {
    praf = 0;
    const vh = w.innerHeight;
    /* perf (2026-10-26): reads first, then writes. A pinned section runs over its height minus its sticky stage's
       (100svh), not minus innerHeight: that changes by ~80px as the iPhone toolbar collapses and made the photos jump */
    const ps = [...near].map(el => {
      const r = el.getBoundingClientRect();
      if (el.dataset.wlProgress === 'pass') return [el, (vh - r.top) / (r.height + vh)];
      const stg = el.wlStage || (el.wlStage = $('.wl-pinned-drift__stage', el) || el.firstElementChild);
      return [el, -r.top / Math.max(1, r.height - ((stg && stg.offsetHeight) || vh))];
    });
    ps.forEach(([el, p]) => setP(el, Math.min(1, Math.max(0, p))));
  };
  const ask = () => { if (!praf) praf = requestAnimationFrame(tick); };
  if (RM.matches || !('IntersectionObserver' in w)) progs.forEach(el => setP(el, 1));
  else {
    const pio = new IntersectionObserver(es => { es.forEach(e => (e.isIntersecting ? near.add(e.target) : near.delete(e.target))); ask(); }, { rootMargin: '50% 0px' });
    progs.forEach(el => { setP(el, 0); pio.observe(el); });
    w.addEventListener('scroll', ask, { passive: true });
    w.addEventListener('resize', ask);
  }
}

/* ---------- living video: only [data-start, data-end) plays, muted; no bytes before load;
   no autoplay under reduced motion or Save-Data. Tap mode (data-live-tap on the scope, or a video printed with
   data-tap): nothing loads or plays until the first tap on the control, which then reads "Pause". ---------- */
const auto = !RM.matches && !(navigator.connection && navigator.connection.saveData);
const scope = v => v.closest('[data-live-scope]');
const live = s => s.dataset.live === 'on';
const tapOnly = s => s.hasAttribute('data-live-tap') || !!$('video[data-tap]', s);
const label = s => {
  const b = $('[data-live-ctl]', s); if (!b) return;
  const on = live(s), u = $('use', b), t = $('span:not(.wl-live__txt)', b);
  b.setAttribute('aria-label', on ? (b.dataset.pause || 'Pause video') : (b.dataset.play || 'Play video'));
  if (u) u.setAttribute('href', on ? '#i-pause' : '#i-play');
  if (t) t.textContent = on ? (b.dataset.pauseText || 'Pause') : (b.dataset.playText || 'Play');
  if (tapOnly(s) && !$('.wl-live__txt', b) && !$('span', b)) { const w = document.createElement('span'); w.className = 'wl-live__txt'; w.textContent = b.dataset.watch || 'Watch'; b.appendChild(w); }
};
const arm = v => {
  const S = +v.dataset.start, E = +v.dataset.end, box = v.parentNode, r = +v.dataset.rate || 1;
  const ok = t => t >= S - 0.02 && t < E;
  const chk = t => { if (t >= E - 0.1 || t < S - 0.05) { if (!ok(t)) box.classList.add('wl-hold'); v.currentTime = S; } };
  const tick = (n, m) => { chk(m ? m.mediaTime : v.currentTime); m ? v.requestVideoFrameCallback(tick) : v.paused || requestAnimationFrame(tick); };
  v.defaultPlaybackRate = r;
  v.addEventListener('loadedmetadata', () => { v.currentTime = S; }, { once: true });
  v.addEventListener('seeked', () => { const in_ = ok(v.currentTime); box.classList.toggle('wl-hold', !in_); if (in_) { v.playbackRate = r; box.classList.add('wl-is-live'); } });
  v.addEventListener('ended', () => chk(E));
  v.addEventListener('timeupdate', () => chk(v.currentTime)); /* a second guard: on a busy phone the frame callback can lag */
  if (v.requestVideoFrameCallback) v.requestVideoFrameCallback(tick); else v.addEventListener('play', () => requestAnimationFrame(tick));
  v.preload = 'auto'; v.src = v.dataset.src + '#t=' + S;
};
const play = v => {
  const s = scope(v);
  if (s && live(s) && v.dataset.vis === '1' && !d.hidden) { v.src || arm(v); const p = v.play(); p && p.catch(() => {}); } else if (v.src) v.pause();
};
const io2 = 'IntersectionObserver' in w ? new IntersectionObserver(es => es.forEach(e => { e.target.dataset.vis = +e.isIntersecting; play(e.target); }), { rootMargin: '25% 0px' }) : null;
let loaded = d.readyState === 'complete';
const pending = [];
const initLive = r => {
  $$('[data-live-scope]', r).forEach(s => { if (!s.dataset.live) { if (tapOnly(s)) s.setAttribute('data-live-tap', ''); s.dataset.live = auto && !tapOnly(s) ? 'on' : 'off'; label(s); } });
  $$('video[data-start]', r).forEach(v => { if (v.dataset.wlInit) return; v.dataset.wlInit = '1'; if (!io2) return; loaded ? io2.observe(v) : pending.push(v); });
};
w.wlInitLive = initLive; /* lets a section start its clips after it swaps its own markup */
if (!loaded) w.addEventListener('load', () => { loaded = true; pending.forEach(v => io2 && io2.observe(v)); });
d.addEventListener('click', e => {
  const b = e.target.closest('[data-live-ctl]'), s = b && scope(b); if (!s) return;
  s.dataset.live = live(s) ? 'off' : 'on'; if (live(s)) s.classList.add('wl-was-live'); label(s); $$('video[data-start]', s).forEach(play);
});
d.addEventListener('visibilitychange', () => $$('video[data-start]').forEach(play));

/* ---------- rails, reveals ---------- */
const initRail = r => {
  if (r.dataset.wlInit) return; r.dataset.wlInit = '1';
  const t = $('.wl-rail__track', r); if (!t) return;
  const [p, n] = $$('.wl-rail__btn', r), bars = $$('.wl-rail__bar i', r);
  const u = () => {
    const m = t.scrollWidth - t.clientWidth, x = t.scrollLeft;
    bars.forEach(i => i.style.setProperty('--p', m > 0 ? Math.min(1, (t.clientWidth + x) / t.scrollWidth) : 1));
    if (p) { p.setAttribute('aria-disabled', x < 4); n.setAttribute('aria-disabled', x > m - 4); }
  };
  const go = (dir, e) => t.scrollBy({ left: dir * t.clientWidth * 0.85, behavior: smooth(e) });
  t.addEventListener('scroll', u, { passive: true });
  if (p) p.addEventListener('click', e => go(-1, e));
  if (n) n.addEventListener('click', e => go(1, e));
  u();
};
const io = 'IntersectionObserver' in w ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('wl-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' }) : null;
const initReveal = r => $$('[data-reveal]', r).forEach(el => { io ? io.observe(el) : el.classList.add('wl-in'); });
/* the reading light (wl-use-conditions): each line lights as it reaches 62% down the screen and dims again below it */
const initLit = r => $$('[data-wl-lit]', r).forEach(box => {
  if (box.dataset.wlLitInit || !('IntersectionObserver' in w)) return; box.dataset.wlLitInit = '1';
  const o = new IntersectionObserver(es => es.forEach(e => {
    const line = e.rootBounds ? e.rootBounds.bottom : w.innerHeight * 0.62;
    e.target.classList.toggle('wl-lit', e.boundingClientRect.top < line);
  }), { rootMargin: '0px 0px -38% 0px' });
  $$('.wl-conds__list > li, .wl-conds__float', box).forEach(i => o.observe(i));
  box.classList.add('wl-lit-on');
});

/* ---------- no photo twice on the product page ----------
   A figure marked data-wl-norepeat (the PDP's FAQ photo, a product scene's photo) hides while the product gallery
   shows the same photo for the picked colour, or a same-shoot twin named in its data-twins (file names, commas).
   Every hero-ok photo already sits in some colour's gallery, so the figure shows for every other colour and steps
   aside for the one that holds it (a scene's second photo, when set, takes its place). Checked on load and whenever
   the gallery changes (a colour change). */
const fileKey = u => { try { return decodeURIComponent(new URL(u, location.href).pathname.split('/').pop()).toLowerCase(); } catch (x) { return ''; } };
const imgKey = i => fileKey(i.getAttribute('src') || (i.getAttribute('srcset') || '').trim().split(/\s/)[0]);
const imgKeys = el => $$('img', el).map(imgKey);
const noRepeat = () => {
  const figs = $$('[data-wl-norepeat]:not([data-wl-norepeat="page"])'); if (!figs.length) return;
  const seen = new Set();
  $$('[data-gallery] li[data-media-id]').forEach(li => { if (!li.hidden) imgKeys(li).forEach(k => k && seen.add(k)); });
  /* inside a host (a product scene) the figures are a first choice and a second: the first that isn't in the gallery
     shows, the others hide; with none left the host gets wl-norepeat-off (its words close up to one column) */
  const hosts = new Map();
  figs.forEach(f => {
    const keys = imgKeys(f).concat((f.dataset.twins || '').toLowerCase().split(',').map(x => x.trim()));
    const rep = keys.some(k => k && seen.has(k));
    const host = f.closest('[data-wl-norepeat-host]');
    if (!host) { if (f.hidden !== rep) f.hidden = rep; return; }
    if (!hosts.has(host)) hosts.set(host, []);
    hosts.get(host).push([f, rep]);
  });
  hosts.forEach((list, host) => {
    let shown = false;
    list.forEach(([f, rep]) => { const show = !rep && !shown; if (show) shown = true; if (f.hidden === show) f.hidden = !show; });
    host.classList.toggle('wl-norepeat-off', !shown);
  });
};
/* a picture marked data-wl-norepeat="page" (a search result's) gives up its photo when the same file shows anywhere
   else on the page (a colour tile below, its hover photo included): the row keeps its plain tinted square */
const noRepeatPage = () => {
  const own = $$('[data-wl-norepeat="page"]'); if (!own.length) return;
  const seen = new Set(); $$('img').forEach(i => { if (!i.closest('[data-wl-norepeat="page"]')) seen.add(imgKey(i)); });
  own.forEach(f => $$('img', f).forEach(i => seen.add(imgKey(i)))); /* rows never share a photo (Liquid sees to that) */
  const tpl = $('template[data-wl-spare]'); let spare = tpl ? $$('img', tpl.content) : [];
  own.forEach(f => $$('img', f).forEach(i => {
    if (!$$('img').some(o => o !== i && !f.contains(o) && imgKey(o) === imgKey(i))) return;
    const alt = spare.find(x => !seen.has(imgKey(x)));
    if (alt) { spare = spare.filter(x => x !== alt); const n = d.importNode(alt, true); i.replaceWith(n); seen.add(imgKey(n)); }
    else { i.hidden = true; f.classList.add('wl-sres2__media--none'); }
  }));
};
const initNoRepeat = () => {
  noRepeatPage();
  const g = $('[data-gallery]'); if (!g || !$('[data-wl-norepeat]:not([data-wl-norepeat="page"])')) return;
  noRepeat();
  let t = 0; const later = () => { clearTimeout(t); t = setTimeout(noRepeat, 80); };
  new MutationObserver(later).observe(g.closest('.shopify-section') || d.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'src'] });
};

/* ---------- the 3D scene (Home, wl-turn-3d): the owner's 3D carrier (Spline) in front of giant words ----------
   One pinned stage, one rAF from scroll progress q (0 → 1 across the pinned scroll; e: 0 → 1 while it scrolls in).
   The beats (blocks) share q by weight. turn: the carrier turns in from its side; close: it turns to a buckle and comes
   right up close; settle: it pulls back and settles front-on; colors: it holds that exact pose while it steps through
   every colour of Theme settings > WaterLand > 3D model colours and back to the first, its name under it (photo,
   optional: it shrinks while a photo opens behind it in a circle, ending on the words in white). Each beat's words rise
   out of their masks, hold whole for at least ~40% of a screen of scroll, and leave by fading (never by the mask, so no
   letter is ever shown half-cut at rest). DOM: transforms and opacity only.
   Nothing loads before the section is within one screen of the viewport. Reduced motion or Save-Data: the still stack
   (wl.css) and "View in 3D" loads a still model on request. _spline, its scene and camera are internal API: when any
   of them is missing, the packshot stays (and swaps colour in the colours beat) and the words still work. */
const initSpin = sec => {
  if (sec.dataset.wlInit) return; sec.dataset.wlInit = '1';
  const box = $('[data-spin-box]', sec), btn = $('[data-spin-load]', sec), st = $('[data-spin-status]', sec), stg = $('.wl-spin__stage', sec);
  if (!box) return;
  const calm = RM.matches || !!(navigator.connection && navigator.connection.saveData);
  const ss = (a, b, t) => { t = Math.min(1, Math.max(0, (t - a) / (b - a))); return t * t * (3 - 2 * t); };
  const mix = (a, b, k) => a + (b - a) * k;
  const beats = $$('[data-beat]', sec).sort((x, y) => +x.dataset.beat - +y.dataset.beat);
  const moves = beats.map(b => b.dataset.move || 'turn');
  const words = beats.map(b => $$('.wl-spin__w > span', b)), lines = beats.map(b => $('small', b));
  const iris = $('[data-spin-iris]', sec), photo = iris && iris.firstElementChild;
  const cn = $('[data-spin-cname]', sec), cnT = cn && $('span', cn), poster = $('[data-spin-poster]', box);
  let COL = []; try { COL = JSON.parse(($('[data-spin-colors]', sec) || {}).textContent || '[]'); } catch (x) { COL = []; }
  /* the beats' stretches of q, by weight */
  const wt = moves.map(m => ({ turn: 1, colors: 2.6, close: 1.25, settle: 1.45, photo: 1.2 }[m] || 1)), tot = wt.reduce((a, b) => a + b, 0) || 1;
  const win = []; wt.reduce((acc, x) => { win.push([acc / tot, (acc + x) / tot]); return acc + x; }, 0);
  const loc = (i, q) => (q - win[i][0]) / Math.max(0.001, win[i][1] - win[i][0]);
  /* the carrier's poses, per beat at local u: ry/rx turn and tilt (rad), k size, a 0 → 1 from its centre to the buckle,
     ty pushes its centre down (share of the screen), op its opacity. Joined into one list over q. */
  const P = { ry: 0, rx: 0.04, k: 1, a: 0, ty: 0.05, op: 1 };
  /* the settled pose: front-on, the words above it, room under it for the colour's name. The settle beat ends on it and
     the colours beat holds it exactly (no swing, no size or height change): only the colour changes (owner) */
  const REST = wide => ({ ry: 0, rx: 0.03, k: wide ? 0.57 : 1.15, a: 0, ty: wide ? 0.112 : 0.03, op: 1 });
  const KEYS = wide => ({
    turn: [[0, { ry: -1.3, rx: 0.07, k: wide ? 0.8 : 1.45, ty: wide ? 0.12 : 0 }], [1, { ry: -0.3, rx: 0.04, k: wide ? 0.72 : 1.05, ty: wide ? 0.1 : 0.03 }]],
    colors: [[0, REST(wide)], [1, REST(wide)]],
    close: [[0.06, { ry: 0.22, rx: 0.05, k: wide ? 0.72 : 1.1, ty: 0.05 }], [0.6, { ry: 0.62, rx: 0.12, k: wide ? 2.2 : 2.7, a: 1 }], [1, { ry: 0.72, rx: 0.13, k: wide ? 2.3 : 2.8, a: 1 }]],
    settle: [[0.03, { ry: 0.7, rx: 0.12, k: wide ? 2.15 : 2.6, a: 1 }], [0.3, REST(wide)], [1, REST(wide)]],
    photo: [[0.04, { ry: 0.7, rx: 0.12, k: wide ? 2.15 : 2.6, a: 1 }], [0.3, { ry: 0.06, rx: 0.03, k: wide ? 0.5 : 0.7, a: 0, ty: 0, op: 1 }], [0.44, { ry: -0.02, k: wide ? 0.4 : 0.56, op: 0 }], [1, { ry: -0.1, k: wide ? 0.38 : 0.52, op: 0 }]]
  });
  let keys = [];
  const build = () => {
    const K = KEYS(WIDE.matches); let last = { ...P }; keys = [];
    moves.forEach((m, i) => (K[m] || K.turn).forEach(([u, o]) => { last = { ...last, ...o }; keys.push([mix(win[i][0], win[i][1], u), last]); }));
  };
  build();
  if (WIDE.addEventListener) WIDE.addEventListener('change', () => { build(); ask(); });
  const pose = q => {
    if (!keys.length) return P;
    if (q <= keys[0][0]) return keys[0][1];
    for (let i = 1; i < keys.length; i++) {
      if (q <= keys[i][0]) { const [q0, a] = keys[i - 1], [q1, b] = keys[i], k = ss(q0, q1, q), o = {}; for (const n in P) o[n] = mix(a[n], b[n], k); return o; }
    }
    return keys[keys.length - 1][1];
  };
  /* colour at q: the colours beat walks every colour and back to the first (the scene's own, an in-stock colour), which
     then holds until the section lets go; the photo beat turns to the photo's */
  const ci = moves.indexOf('colors'), pi = moves.indexOf('photo'), endHex = sec.dataset.spinEndTint || '';
  const SEQ = COL.length > 1 ? COL.concat([COL[0]]) : COL;
  const C0 = 0.2, C1 = 0.8; /* the first step comes once the words are up; from C1 the last colour holds */
  /* stepped, never scrubbed or morphed: each step switches the colour at once, in the same frame as the name under it,
     so the carrier never shows an in-between mix and the name always matches it (owner, 2026-10-15) */
  const colour = q => {
    const m = SEQ.length - 1; if (m < 0) return null;
    let c = SEQ[0];
    if (ci > -1 && m > 0) { const u = loc(ci, q); c = SEQ[u < C0 ? 0 : Math.min(m, 1 + Math.floor((u - C0) / ((C1 - C0) / Math.max(1, m - 1))))]; }
    const out = { hex: c[1], name: c[0], sw: c[2], pack: c[3], url: c[4] };
    if (pi > -1 && /^#[0-9a-f]{6}$/i.test(endHex) && ss(0.1, 0.4, loc(pi, q)) > 0.5) out.hex = endHex;
    return out;
  };
  const FOCUS = () => (WIDE.matches ? [0.4, -0.42] : [0.06, -0.24]); /* where the buckle comes to rest (NDC) */
  let v, app, obj, grp, cam, V, base, p0, s0, cL, fL, t1, t2, t3, LB = null, MM = null, lowKey = '', lowY = -1, solve = false, tintOk = false, is3d = false, zoom = 1, raf = 0;
  /* perf (2026-10-22): onScr: the section is on screen (or within a quarter screen of it); only then does it paint and
     only then does Spline draw. last3: the pose last handed to Spline; a frame whose pose, colour and screen are all
     unchanged leaves the model alone, so Spline isn't asked to redraw a picture it already shows */
  let onScr = false, last3 = '';
  const put = (el, k, val) => { if (!el) return; const m = el.wlPut || (el.wlPut = {}); if (m[k] !== val) { m[k] = val; el.style[k] = val; } };
  let lastCol = '', lastPack = SEQ.length ? SEQ[0][3] : '';
  const GAP = 28; /* px of clear space between the carrier's lowest point and its colour's name */
  const paint = () => {
    raf = 0;
    if (!sec.isConnected) { w.removeEventListener('scroll', ask); w.removeEventListener('resize', ask); return; } /* the editor replaced the section */
    /* perf (2026-10-26): the pin runs over the stage's own height (100svh), steady while the iPhone toolbar moves */
    const r = sec.getBoundingClientRect(), vh = w.innerHeight, sv = (stg && stg.offsetHeight) || vh, span = r.height - sv;
    const q = span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 0, e = Math.min(1, Math.max(0, (vh - r.top) / vh));
    /* layout reads first (the stage, the name, the packshot), before this frame writes anything */
    const uc = ci > -1 ? loc(ci, q) : -1, nameOn = !!cn && uc > -0.05, sh = nameOn ? box.clientHeight : 0, ch = nameOn ? cn.offsetHeight : 0;
    const pl = nameOn && !is3d && poster ? [poster.offsetTop, poster.offsetHeight, poster.offsetWidth] : null;
    /* words: each word rises out of its mask; the beat holds whole, then fades as a line before the next arrives */
    words.forEach((ws, i) => {
      const u = loc(i, q), lastBeat = i === beats.length - 1, m = moves[i];
      ws.forEach((sp, j) => {
        const inK = i === 0 ? ss(0.2 + 0.07 * j, 0.7 + 0.07 * j, e) : m === 'photo' ? ss(0.46 + 0.05 * j, 0.66 + 0.05 * j, u) : m === 'settle' ? ss(0.1 + 0.03 * j, 0.22 + 0.03 * j, u) : ss(0.02 + 0.03 * j, 0.14 + 0.03 * j, u);
        put(sp, 'transform', `translate3d(0,${((1 - inK) * 125).toFixed(1)}%,0)`);
      });
      put(beats[i], 'opacity', (lastBeat ? 1 : 1 - ss(0.86, 0.94, u)).toFixed(3));
      if (lines[i]) put(lines[i], 'opacity', (m === 'photo' ? ss(0.62, 0.74, u) : m === 'settle' ? ss(0.3, 0.4, u) : ss(0.1, 0.2, u)).toFixed(3));
    });
    /* the photo opens in a circle from the carrier's centre (the circle grows, the photo inside holds still) */
    if (iris && pi > -1) {
      const k = ss(0.18, 0.56, loc(pi, q)), s = Math.max(0.0001, k * k * (1.6 - 0.6 * k));
      put(iris, 'transform', `scale(${s.toFixed(4)})`);
      if (photo) put(photo, 'transform', `scale(${(1 / s).toFixed(3)})`);
    }
    /* the colour's name, under the carrier, in the colours beat only */
    const c = colour(q);
    if (cn && ci > -1) {
      const op = c && (is3d ? tintOk : !!poster) ? ss(0.04, 0.12, uc) * (ci === beats.length - 1 ? 1 : 1 - ss(0.9, 0.98, uc)) : 0;
      put(cn, 'opacity', op.toFixed(3));
      put(cn, 'visibility', op > 0.02 ? 'visible' : 'hidden'); /* a link: not clickable or focusable while unseen */
      if (c && cnT && cn.wlName !== c.name) { cn.wlName = c.name; cnT.textContent = c.name; cn.style.setProperty('--c', c.sw); if (c.url) cn.href = c.url; }
    }
    const o = pose(q);
    let low = -1; /* the carrier's lowest point on the stage (px), for the name */
    put(box, 'opacity', o.op.toFixed(3));
    const k3 = is3d && obj ? [o.ry, o.rx, o.k, o.a, o.ty, c ? c.hex : '', nameOn ? sh : -1, w.innerWidth, sv, zoom].join() : '';
    if (is3d && obj && k3 === last3) { if (solve && nameOn && LB && MM) low = lowY; } /* nothing moved: the model holds */
    else if (is3d && obj) {
      last3 = k3;
      try {
        obj.rotation.y = base.y + o.ry; obj.rotation.x = base.x + o.rx;
        obj.scale.x = obj.scale.y = obj.scale.z = s0 * o.k;
        obj.position.x = p0.x; obj.position.y = p0.y; obj.position.z = p0.z;
        if (solve) {
          /* move the carrier so the point between its centre and the buckle sits where it should on screen */
          grp.updateMatrixWorld(true);
          const W = grp.localToWorld(t1.copy(cL).lerp(fL, o.a)), n = t2.copy(W).project(cam), f = FOCUS();
          const T = t3.set(mix(0, f[0], o.a), mix(-2 * o.ty, f[1], o.a), n.z).unproject(cam);
          obj.position.x = p0.x + T.x - W.x; obj.position.y = p0.y + T.y - W.y; obj.position.z = p0.z + T.z - W.z;
          if (nameOn && LB && MM) {
            /* worked out again only when the pose or the screen changes (in the colours beat the pose holds) */
            const key = [o.ry, o.rx, o.k, o.a, o.ty].map(x => x.toFixed(4)).join() + sh + 'x' + w.innerWidth + 'z' + zoom;
            if (key !== lowKey) {
              grp.updateMatrixWorld(true); cam.updateMatrixWorld();
              const E = MM.multiplyMatrices(cam.projectionMatrix, cam.matrixWorldInverse).multiply(grp.matrixWorld).elements;
              let m = -Infinity;
              for (let i = 0; i < LB.length; i += 3) { const x = LB[i], y = LB[i + 1], z = LB[i + 2], yy = -(E[1] * x + E[5] * y + E[9] * z + E[13]) / (E[3] * x + E[7] * y + E[11] * z + E[15]); if (yy > m) m = yy; }
              lowKey = key; lowY = (1 + m) / 2 * sh;
            }
            low = lowY;
          }
        }
        if (c && tintOk && c.hex !== lastCol) { w.wlTint.mix(app, c.hex, c.hex, 1); lastCol = c.hex; }
        /* perf (2026-10-26): one frame, drawn now, only when something changed (Spline's own loop stays stopped) */
        if (typeof app.render === 'function') app.render(); else if (typeof app.requestRender === 'function') app.requestRender();
      } catch (x) {}
    } else if (poster) {
      /* the packshot stands in: its size and its colour follow the scene */
      put(poster, 'transformOrigin', `${mix(50, 22, o.a).toFixed(1)}% 30%`); /* centred, or on the buckle in the close-up */
      put(poster, 'transform', `translate3d(0,${(o.ty * vh).toFixed(1)}px,0) scale(${o.k.toFixed(3)})`);
      /* the packshot's carrier is about 66% of its square, centred: its lowest point is 0.33 of the side below the middle */
      if (pl) { const oy = pl[0] + 0.3 * pl[1]; low = oy + (pl[0] + pl[1] / 2 + 0.33 * Math.min(pl[1], pl[2]) - oy) * o.k + o.ty * vh; }
      if (c && c.pack && ci > -1 && c.pack !== lastPack) { lastPack = c.pack; poster.srcset = srcset(c.pack, [480, 720, 960, 1280]); poster.src = wurl(c.pack, 960); }
    }
    /* the name sits GAP px under the carrier's lowest point (it never overlaps it); the pose holds, so it holds too */
    if (nameOn && low > 0) put(cn, 'top', `${Math.round(Math.min(low + GAP, sh - ch - 16))}px`);
  };
  const ask = () => { if (!raf && onScr) raf = requestAnimationFrame(paint); };
  /* Spline's render loop runs only while the section is on screen (stop() cancels it; play() restarts it and turns the
     orbit controls back on, so they are switched off again). Spline's own scroll listener reads the canvas's position
     on every scroll event (for pointer events, which this scene does not use while scrolled): it is off while stopped. */
  const gl3d = () => {
    if (!app || typeof app.stop !== 'function') return;
    try {
      if (onScr) {
        /* perf (2026-10-26): on iPhones a WebGL canvas that redraws every frame inside the pinned stage stalls scrolling
           (WebKit bug 255597). Spline's loop drew ~60 frames a second even when nothing moved; now it stays stopped and
           paint() draws one frame only when the pose, the colour or the screen changes. Spline's scroll listener stays off. */
        if (!app.isStopped) app.stop();
        if (scrolled() && app.controls) { const ct = app.controls; ct.enabled = false; if (ct.orbitControls) ct.orbitControls.enabled = false; }
        if (!app.wlNoScroll && typeof app._onScroll === 'function') { app.wlNoScroll = true; d.removeEventListener('scroll', app._onScroll); }
        last3 = ''; lowKey = ''; ask(); /* and the name's place is worked out again from the settled camera */
      } else {
        if (!app.isStopped) { app.stop(); last3 = ''; } /* the next paint on screen hands Spline its pose again */
        if (!app.wlNoScroll && typeof app._onScroll === 'function') { app.wlNoScroll = true; d.removeEventListener('scroll', app._onScroll); }
      }
    } catch (x) {}
  };
  /* Spline scales the model with the box height; its setZoom() is relative, so only the change is applied */
  const fit = () => {
    const rr = v && v.getBoundingClientRect(), z = rr && rr.height ? (+sec.dataset.spinZoom || 0.9) * Math.min(1, rr.width / rr.height) : 0;
    if (!z || !app || typeof app.setZoom !== 'function' || Math.abs(z - zoom) < 0.001) return;
    app.setZoom(z / zoom); zoom = z;
  };
  const scrolled = () => sec.classList.contains('wl-spin--scroll');
  const load = () => {
    if (v || !sec.dataset.spinJs || !sec.dataset.spinScene || !hasGL()) return; /* no WebGL: the packshot stays */
    /* perf (2026-10-26, owner): phones get the colour photos, not the 3D. On iPhones the WebGL scene (its 2 MB viewer,
       its build and its canvas in the pinned stage) made scrolling jump even when it drew only on change. Desktop keeps it. */
    if (!WIDE.matches) { prePacks(); return; }
    if (!customElements.get('spline-viewer') && !$('script[data-wl-spline]')) { const sc = d.createElement('script'); sc.type = 'module'; sc.src = sec.dataset.spinJs; sc.dataset.wlSpline = ''; d.head.append(sc); }
    v = d.createElement('spline-viewer');
    v.hint = false; /* hint is a Boolean property: the attribute hint="" would switch the drag hint ON */
    v.setAttribute('aria-hidden', 'true');
    v.setAttribute('loading', 'eager'); /* perf (2026-10-22): Spline otherwise waits until the viewer is on screen, then builds the scene mid-scroll */
    v.setAttribute('url', sec.dataset.spinScene);
    v.addEventListener('load-complete', () => {
      app = v._spline;
      try { const R = app && app._renderer; if (R && typeof R.setPixelRatio === 'function' && (typeof R.getPixelRatio === 'function' ? R.getPixelRatio() : w.devicePixelRatio) > 2) { R.setPixelRatio(2); R.viewportWidth = -1; if (typeof app._resize === 'function') app._resize(); } } catch (x) {}
      try { fit(); } catch (x) {}
      try { obj = app && app.findObjectByName(sec.dataset.wlObject || 'Group'); } catch (x) { obj = null; }
      if (obj && obj.rotation) { base = { x: obj.rotation.x, y: obj.rotation.y }; p0 = { x: obj.position.x, y: obj.position.y, z: obj.position.z }; s0 = obj.scale.x; }
      else obj = null;
      /* the position solve needs the scene graph and the camera (internal); without them the carrier only turns */
      try {
        const sc = app._scene; cam = app._camera; V = sc.position.constructor;
        grp = sc.getObjectByProperty('uuid', obj.uuid);
        let B3 = null; sc.traverse(m => { if (!B3 && m.isMesh && m.geometry) { m.geometry.computeBoundingBox(); B3 = m.geometry.boundingBox.constructor; } });
        sc.updateMatrixWorld(true);
        cL = grp.worldToLocal(new B3().setFromObject(grp).getCenter(new V()));
        const part = sec.dataset.spinPart && sc.getObjectByName(sec.dataset.spinPart);
        fL = part ? grp.worldToLocal(new B3().setFromObject(part).getCenter(new V())) : cL.clone();
        t1 = new V(); t2 = new V(); t3 = new V();
        solve = !!(cam && cam.isCamera && grp && typeof t2.project === 'function');
        /* the carrier's own points (its visible parts, up to 1500 per part), in its own space, gathered once: to set the
           colour's name clear under the carrier, its lowest point on screen is found from these */
        try {
          const inv = grp.matrixWorld.clone(), M = inv.clone(), pt = new V(), a = [];
          if (inv.invert) inv.invert(); else inv.getInverse(grp.matrixWorld);
          grp.traverse(m => {
            const pos = m.isMesh && m.geometry && m.geometry.attributes && m.geometry.attributes.position; if (!pos) return;
            for (let o = m; o && o !== grp; o = o.parent) if (o.visible === false) return;
            M.copy(inv).multiply(m.matrixWorld);
            for (let i = 0, k = Math.max(1, Math.ceil(pos.count / 1500)); i < pos.count; i += k) { pt.fromBufferAttribute(pos, i).applyMatrix4(M); a.push(pt.x, pt.y, pt.z); }
          });
          if (a.length) { LB = new Float32Array(a); MM = new grp.matrixWorld.constructor(); }
        } catch (x) { LB = null; }
      } catch (x) { solve = false; }
      if (scrolled() && app && app.controls) try { app.controls.enabled = false; } catch (x) {}
      /* the colours (wl-3d-tint.js); if they can't be applied, only the scene's own colour may show */
      tintOk = !!(w.wlTint && w.wlTint.mix && COL.length && w.wlTint.mix(app, COL[0][1], COL[0][1], 0));
      if (!tintOk && sec.dataset.spinTint && w.wlTint) w.wlTint(app, sec.dataset.spinTint, 0);
      if (!tintOk && sec.dataset.spinOwn !== 'true') return;
      is3d = true; sec.classList.add('wl-is-3d');
      if (scrolled()) paint(); else say(st, (st && st.dataset.ready) || '3D view ready.');
      /* built while still off screen (the usual case now): let Spline draw its first frames in the right pose, then rest */
      if (scrolled()) setTimeout(gl3d, 1200);
    }, { once: true });
    if (w.ResizeObserver) new ResizeObserver(() => { try { fit(); } catch (x) {} ask(); }).observe(v);
    box.append(v);
  };
  if (calm || !('IntersectionObserver' in w)) {
    if (btn && hasGL()) { btn.hidden = false; btn.addEventListener('click', () => { sec.classList.add('wl-spin--free'); btn.hidden = true; load(); }); }
    return;
  }
  sec.classList.add('wl-spin--scroll');
  w.addEventListener('scroll', ask, { passive: true }); w.addEventListener('resize', ask);
  paint();
  /* perf (2026-10-22): paint (and let Spline draw) only while the section is on screen or within a quarter screen of
     it; one more paint as it crosses that line sets the pose it is left in */
  new IntersectionObserver(([en]) => {
    onScr = en.isIntersecting;
    if (onScr) gl3d(); else setTimeout(() => { if (!onScr) gl3d(); }, 700); /* leaving: Spline first draws that last pose */
    if (!raf) raf = requestAnimationFrame(paint);
  }, { rootMargin: '25% 0px' }).observe(sec);
  /* perf (2026-10-22): the 3D is built ahead of time, at the first pause in scrolling (200ms) once the section is
     within two screens, or at one screen away at the latest, so the heavy build never lands in the middle of a flick */
  let rt = 0;
  const go = () => { clearTimeout(rt); w.removeEventListener('scroll', rest); load(); };
  const rest = () => { clearTimeout(rt); rt = setTimeout(go, 500); }; /* perf (2026-10-26): a real pause (was 200ms) */
  const far = new IntersectionObserver(([en]) => { if (!en.isIntersecting) return; far.disconnect(); w.addEventListener('scroll', rest, { passive: true }); rest(); }, { rootMargin: '200% 0px' });
  /* with no 3D (no WebGL), the packshot stands in and steps through the colours: fetch those packshots now, so no
     step waits for its photo mid-scroll */
  /* perf (2026-10-26): the colour photos are fetched and unpacked one at a time at idle moments, starting soon after
     load, not all seven at once a screen before the section (that burst froze scrolling for ~0.3 s on an iPhone) */
  let packsOn = false;
  const prePacks = () => {
    if (!poster || packsOn) return; packsOn = true;
    const list = SEQ.map(c => c[3]).filter((u, i, a) => u && a.indexOf(u) === i);
    const next = () => {
      const u = list.shift(); if (!u) return;
      const i = new Image(); i.decoding = 'async'; i.sizes = poster.sizes; i.srcset = srcset(u, [480, 720, 960, 1280]);
      (i.decode ? i.decode().catch(() => {}) : Promise.resolve()).then(() => (w.requestIdleCallback ? w.requestIdleCallback(next, { timeout: 1500 }) : setTimeout(next, 80)));
    };
    next();
  };
  /* perf (2026-10-26): a screen away it still waits for a pause (the packshot stands in until then), never mid-flick */
  const near = new IntersectionObserver(([en]) => { if (!en.isIntersecting) return; near.disconnect(); far.disconnect(); if (!v) { prePacks(); w.addEventListener('scroll', rest, { passive: true }); rest(); } }, { rootMargin: '100% 0px' });
  far.observe(sec); near.observe(sec);
  /* perf (2026-10-22, pack 3): like the product page's gallery 3D, start building as soon as the page has loaded, at
     the first pause in scrolling wherever the visitor is (usually still on the hero), so the heavy build never lands
     mid-flick on the way down to this section. The two observers above stay as the fallback. */
  const early = () => { if (v) return; if (!WIDE.matches && hasGL()) { far.disconnect(); near.disconnect(); prePacks(); return; } far.disconnect(); w.addEventListener('scroll', rest, { passive: true }); rest(); };
  if (d.readyState === 'complete') setTimeout(early, 1200); else w.addEventListener('load', () => setTimeout(early, 1200), { once: true });
};

/* jump pills: a pill whose section is hidden until the owner fills it (no anchor on the page) is hidden too */
const initJumps = () => $$('.wl-phero__pills a[href^="#"]').forEach(a => { const li = a.closest('li'); if (li) li.hidden = !d.getElementById(decodeURIComponent(a.hash.slice(1))); });

/* Shopify's own overlays (the preview bar on preview links, the floating toolbar in Customize) sit on top of the page's
   bottom edge. Customers never see them, but they covered the bag's Checkout button and the phone buy bar while testing.
   --wl-obstruct lifts both clear; it stays 0 on the live store. */
const obstruct = () => {
  let h = 0;
  const pb = d.getElementById('PBarNextFrameWrapper') || d.getElementById('preview-bar-iframe');
  if (pb) { const r = pb.getBoundingClientRect(); if (r.height && r.top < innerHeight) h = Math.round(innerHeight - r.top); }
  if (w.Shopify && w.Shopify.designMode) h = Math.max(h, 88);
  /* perf (2026-10-22): a value set on <html> restyles the whole page, and phones fire resize whenever the URL bar moves */
  if (obstruct.h !== h) { obstruct.h = h; d.documentElement.style.setProperty('--wl-obstruct', h + 'px'); }
};
obstruct();
addEventListener('resize', obstruct);
new MutationObserver(obstruct).observe(d.body, { childList: true });
[800, 3000].forEach(t => setTimeout(obstruct, t));

const init = (r = d) => {
  initJumps();
  $$('[data-stage]', r).forEach(initStage);
  $$('[data-rail]', r).forEach(initRail);
  $$('[data-marquee]', r).forEach(initMarquee);
  $$('[data-spin]', r).forEach(initSpin);
  initReveal(r);
  initLit(r);
  initLive(r);
};
init();
initNoRepeat();
/* theme editor: sections reload in place */
d.addEventListener('shopify:section:load', e => { heroC = undefined; init(e.target); fo(); headerState(); });
})();
